import components from "@ali/vc-recept/build/view";
import { isNil, get, isEmpty } from "lodash";
import request from "@/service/base";
import {
  registerModuleExternals,
  registerMaterials,
  getRegistryModuleById,
} from "@alife/gov-render-sdk/es/engine/modules";

const moduleExternals = {
  React: require("react"),
  ReactDOM: require("react-dom"),
  Next: require("@alifd/next"),
  "prop-types": require("prop-types"),
};

//新增: aone.alibaba-inc.com/v2/project/1061355/req/40261117
export function renderCompResource(url = "/form/renderCompResource", params) {
  return request({
    url,
    method: `GET`,
    params,
  });
}

// 动态加载远端扩展模块
export function getRemoteModule(url, params) {
  return new Promise((resolve, reject) => {
    renderCompResource(url, params)
      .then((resources) => {
        const resourceData = get(resources, "data", [])
          .map((i) => {
            // 处理接口返回的扩展组件配置 { compType: '组件类型', compResource: { pc: {js: '',css: '',},}, }
            if (!i || isNil(i.compResource) || !i.compType) {
              return null;
            }

            let compResource = null;
            // 将类富文本数据转换成标准的 JavaScript 对象
            try {
              compResource = new Function("return " + i.compResource)();
              compResource = JSON.parse(JSON.stringify(compResource));
            } catch (err) {}

            // 如果不是pc端扩展组件或不存在扩展js，则过滤掉
            if (
              !compResource ||
              !get(compResource, "pc") ||
              !get(compResource, "pc.js")
            ) {
              return null;
            }

            // 提取 pc 配置
            return { ...i, compResource: compResource.pc };
          })
          .filter((i) => i);

        // isv没有定制组件的时候，服务端也会返回全量的组件数据，这里过滤
        if (isEmpty(resourceData)) {
          resolve([]);
          return;
        }

        // 将组件配置转换成 materialsConfig 配置形式
        const materialsConfig = {};
        resourceData.forEach((i) => {
          materialsConfig[i.compType] = {
            assets: {
              js: get(i, "compResource.js"),
              css: get(i, "compResource.css", ""),
            },
            moduleInfo: {
              library: `module_${i.compType}`, // 扩展表单组件导出 library 规则必须是"module_组件类型"
              // moduleName: "default", // 构建&加载模块使用单一模块模式，default就是模块，不必设置moduleName
            },
          };
        });

        // 注册指定唯一标识与模块的对应关系配置
        registerMaterials(materialsConfig);

        // 为扩展模块注册公共依赖排包
        registerModuleExternals(moduleExternals);

        Promise.all(
          Object.keys(materialsConfig).map(async (compType) => {
            const mod = await getRegistryModuleById(
              get(materialsConfig, `${compType}.moduleInfo.library`),
              "single" // 单一模块模式获取表单扩展组件
            );

            return mod || null;
          })
        )
          .then((values) => {
            resolve(values.filter((i) => i));
          })
          .catch((err) => reject(err));
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export default components;
